var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore
import style from './ModalLoading.css';
export var ModalLoading = function () {
    return (_jsx("div", __assign({ className: "modal fade ", id: "ModalLoading", tabIndex: -1, role: "dialog", "aria-labelledby": "exampleModalLabel", "aria-hidden": "true", "data-backdrop": "true" }, { children: _jsxs("div", __assign({ className: style.div }, { children: [_jsx("i", { className: "fa-3x fas fa-spinner fa-spin " + style.faSpinner }, void 0), _jsx("div", __assign({ className: style.loading }, { children: "Loading..." }), void 0)] }), void 0) }), void 0));
};
